const defaultTenantBrand = {
  id: "clikkle",
  name: "Clikkle",
  productName: "Clikkle Identity",
  lockup: "/images/clikkle/brand/logos/clikkle-light.svg",
  mark: "/images/clikkle/brand/logos/clikkle-mark.png",
  arrivalLockup: "/images/clikkle/brand/logos/clikkle-arrival-lockup.png",
  arrivalTagline: "Connect. Create. Accelerate.",
  favicon: "/images/clikkle/brand/icons/favicon.ico",
  wordmark: "Clikkle",
  accent: "#69b8ff",
  accentWarm: "#ffb347",
  homeUrl: "https://clikkle.com",
  supportUrl: "https://clikkle.com/support",
  privacyUrl: "https://clikkle.com/privacy",
  termsUrl: "https://clikkle.com/terms",
  scene: "clikkle-headquarters",
  copy: {
    eyebrow: "CLIKKLE IDENTITY",
    headline: "Enter your digital ecosystem.",
    body: "One identity. Every destination.",
  },
};

export function resolveTenantBrand() {
  // V1 authority. Future Core BaaS/IaaS tenant configuration will be resolved
  // from a validated custom-domain or tenant bootstrap response.
  return defaultTenantBrand;
}

export { defaultTenantBrand };
